@if (isActive()) {
  <app-spinner />
}
@if (isLoadingActive()) {
  <app-loading [message]="loadingMessage()" [fullScreen]="fullScreen()" />
}



